/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/
import * as React from 'react';

export interface IAccountInvoiceTileDescription {
    description: string;
}

export const AccountInvoiceTileDescription: React.FC<IAccountInvoiceTileDescription> = ({ description }) => (
    <p className='ms-account-invoice-tile__description'>{description}</p>
);
